/**
 * Screen related helper functions.
 */
const MXM = 100

export const ScreenUtils = {

    /**
     * calculate the current percentage of the page that is viewed
     *
     * @return % of page viewed
     */
    currentPageViewPercentage(): number {
        return Math.round(
            (window.innerHeight + window.pageYOffset) / (document.body.scrollHeight) * MXM)
    },

    /**
     * calculate the current percentage of the page up to given element that is viewed
     *
     * @return % of page viewed up to given element
     */
    currentElementViewPercentage(el: Element): number {
        const percentage = Math.round(
            (window.innerHeight + window.pageYOffset) / (el.getBoundingClientRect().top + window.pageYOffset) * MXM)
        if (percentage > MXM) {
            return MXM
        }
        return percentage
    }
}
